import { mergeProps } from 'react-aria';
import { useOverlayTriggerState } from 'react-stately';

/**
 * Hook for building an accessible overlay.
 *
 * @param options - Options for the hook.
 */ function useOverlay(options) {
    const { defaultOpen, onClose, onOpen, onOpenChange, open } = options;
    return useOverlayTriggerState(mergeProps({
        defaultOpen,
        isOpen: open,
        onOpenChange
    }, {
        onOpenChange: (open)=>(open ? onOpen : onClose)?.()
    }));
}

export { useOverlay };
//# sourceMappingURL=use-overlay.js.map
